import { type PropsWithChildren, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSymbolStore } from '@/stores/symbol';

type Props = {
  name?: string;
  slug: string;
};

const SymbolBlock = ({ name, slug, children }: PropsWithChildren<Props>) => {
  const { t } = useTranslation();
  const setScrollRefs = useSymbolStore((s) => s.setScrollRefs);
  const observe = useSymbolStore((s) => s.getCurrentObserver);

  const bindRef = useCallback((ref: HTMLDivElement) => {
    const currentObserve = observe();

    setScrollRefs(slug, ref);

    if (ref && currentObserve) {
      currentObserve.observe(ref);
    }
  }, []);

  return (
    <div
      key={name}
      id={name}
      ref={bindRef}
      className='mb-2 flex flex-col last:mb-0'>
      {name && <div className='px-2 text-sm'>{t(name)}</div>}
      {children}
    </div>
  );
};

export default SymbolBlock;
